export default __webpack_public_path__ + "static/media/Schnider_logo.7e77f44c.webp";